import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import PowinBessDetails from '@components/Battery/Powin/PowinBessDetails';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import PowinBessRackList from './PowinBessRackList';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

interface Props {
  selectedBessId: string;
  bessName: string | undefined;
  open: boolean;
  powinControllerName: string;
  onClose: () => void;
}

function PowinBessDetailsModal(props: Props) {
  const { selectedBessId, open } = props;

  return (
    <Dialog onClose={props.onClose} open={open} maxWidth='md' fullWidth>
      <StyledDialogTitle>
        {props.powinControllerName}: {props.bessName}
        <FormattedAlias id='Details' />
        <IconButton onClick={props.onClose} sx={{ mr: -2, mt: -1 }}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent dividers>
        <Box sx={{ mt: 1, mb: 5 }}>
          {open ? (
            <>
              <PowinBessDetails selectedBessId={selectedBessId} />
              <PowinBessRackList selectedBessId={selectedBessId} />
            </>
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default PowinBessDetailsModal;
